import { NewBadgesService } from './new-badges-service';

export default NewBadgesService;
